import React from 'react';
// import ReactDOM from 'react-dom';
import 'antd-mobile/dist/antd-mobile.css';
import { Accordion, List } from 'antd-mobile';
// import { List } from 'antd-mobile';
import intl from 'react-intl-universal';

// import Script from 'react-load-script';


const Item = List.Item;

class faq extends React.Component {



    render() {
        const lang = navigator.language;
        console.log(lang);
        return (
            <div style={{ marginTop: 10, marginBottom: 10 }}>
                <Accordion defaultActiveKey="0" className="my-accordion" onChange={this.onChange} defaultActiveKey>
                    <Accordion.Panel header={intl.get('q1')} className="pad">
                        <p>{intl.get('a1')}</p>
                    </Accordion.Panel>
                    <Accordion.Panel header={intl.get('q2')} className="pad">
                        <p>{intl.get('a2')}</p>
                    </Accordion.Panel>
                    <Accordion.Panel header={intl.get('q3')} className="pad">
                        <p>{intl.get('a3')}</p>
                    </Accordion.Panel>
                </Accordion>

            </div>

            // <div>
            //     <List renderHeader={() => 'FAQ'}>
            //         <Item
            //             thumb="https://zos.alipayobjects.com/rmsportal/dNuvNrtqUztHCwM.png"
            //             arrow="horizontal"
            //             onClick={() => { this.props.history.push('/faq/page1') }}
            //         >
            //             {intl.getHTML('q1')}
            //         </Item>
            //         <Item
            //             thumb="https://zos.alipayobjects.com/rmsportal/UmbJMbWOejVOpxe.png"
            //             onClick={() => { this.props.history.push('/faq/page2') }}
            //             arrow="horizontal"
            //         >
            //             {intl.getHTML('q1')}
            //         </Item>
            //     </List>
            // </div>
        );
    }


}





export default faq;


// function add_chatinline() {
//     var hccid = 55740956;
//     var nt = document.createElement("script");
//     nt.async = true;
//     nt.src = "https://mylivechat.com/chatinline.aspx?hccid=" + hccid;

//     var ct = document.getElementsByTagName("script")[0];
//     ct.parentNode.insertBefore(nt, ct);
// }
// add_chatinline()
